import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { chatActions } from "../../../di/di";
import { AlertTriangle } from "lucide-react";
import { clearChatMessages } from "../state/chat_slice";
import { useStore } from "react-redux";
import { Toast } from "primereact/toast";
import { useRef } from "react";

const ClearChatModalComponent = ({ onClose }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const toastRef = useRef(null);
  const chatChannelId = useSelector((state) => state.chat.chatData.id);
  const isClearingChat = useSelector((state) => state.chat.isClearingChat);

  const handleClearChat = () => {
    clearChatMessages(dispatch, store, {
      chatChannelId,
      resultCallback: (result) => {
        onClose();
        toastRef.current.show({
          severity: "success",
          summary: "Success",
          detail: "Chat history has been cleared",
          life: 3000,
        });
        window.location.reload();
      },
      errorCallback: (error) => {
        onClose();
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: error.message || "Failed to clear chat history",
          life: 3000,
        });
      },
    });
  };

  return (
    <div className="fixed lg:ml-60 inset-0 flex items-center justify-center bg-black bg-opacity-70">
      <Toast ref={toastRef} position="top-right" />
      <div className="absolute">
        <div className="w-[20rem] sm:w-[30rem] bg-gradient-to-b from-slate-950 to-fuchsia-950/80 border border-red-900/30 rounded-xl p-6 mx-4 animate-fade-in">
          <h3 className="text-xl font-bold text-pink-200 mb-4">Clear Chat History</h3>
          <div className="mb-6">
            <p className="text-base text-pink-300 mb-4">Are you sure you want to clear all chat messages? This action cannot be undone.</p>
            <div className="bg-slate-900/50 backdrop-blur-sm p-4 rounded-lg border border-red-900/20">
              <div className="flex items-center">
                <div className="w-10 h-10 flex-shrink-0 bg-red-900/20 rounded-full flex items-center justify-center mr-3">
                  <AlertTriangle size={20} className="text-pink-400" />
                </div>
                <p className="text-sm text-white">All chat history and memory will be permanently erased.</p>
              </div>
            </div>
          </div>
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              disabled={isClearingChat}
              className="text-base px-4 py-2 text-white bg-slate-900/70 rounded-md hover:bg-red-900/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-md active:translate-y-0.5 active:shadow-none"
            >
              No
            </button>
            <button
              onClick={handleClearChat}
              disabled={isClearingChat}
              className="text-base px-4 py-2 text-white bg-gradient-to-r from-red-800 via-red-900 to-red-950 rounded-md hover:opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed active:translate-y-0.5 active:shadow-none"
            >
              {isClearingChat ? "Clearing..." : "Yes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClearChatModalComponent;
